import React from 'react';

import { Box, Typography } from '@material-ui/core';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Element } from 'react-scroll';

import RepeatIcon from '../../../../assets/icons/RepeatIcon';
import TestIcon from '../../../../assets/icons/TestIcon';
import { CustomButton } from '../../../../components/UI/CustomButton';
import { colorsPalette } from '../../../../theme';
import useStyles from './styles';

interface PathwayTestBlockProps {
  id?: string;
  canPassTest: boolean;
  testPassed: boolean;
  title?: string | null;
  wrapperClass?: string;
  link: string;
}

const PathwayTestBlock: React.FC<PathwayTestBlockProps> = ({
  id,
  canPassTest,
  testPassed,
  title,
  wrapperClass,
  link,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const description = testPassed
    ? t('page.pathway.retakeTestDesc')
    : canPassTest
    ? t('page.pathway.completedAllDesc')
    : t('page.pathway.completeAllDesc');

  return (
    <Element
      data-testid="pathwayTest"
      id={`test-${id}`}
      className={cx(classes.wrapper, wrapperClass)}
    >
      <Box className={cx(classes.leftPanel, classes.leftPanelMargin)}>
        <TestIcon className={classes.testIcon} color={colorsPalette.blue} />
        <Box>
          <Typography className={classes.title}>
            {t('page.pathway.test')}: {title}
          </Typography>
          <Typography className={classes.description}>{description}</Typography>
        </Box>
      </Box>
      {!canPassTest && (
        <CustomButton
          data-testid="takeTestDisabled"
          btnClass={classes.takeBtn}
          disabledClass={classes.disabledBtn}
          disabled
        >
          {t('page.pathway.takeTest')}
        </CustomButton>
      )}
      {canPassTest && (
        <Link className={classes.link} to={link}>
          <CustomButton btnClass={testPassed ? classes.btn : ''}>
            {testPassed ? (
              <>
                <RepeatIcon color={colorsPalette.white} className={classes.retakeIcon} />
                {t('page.pathway.retakeTest')}
              </>
            ) : (
              t('page.pathway.takeTest')
            )}
          </CustomButton>
        </Link>
      )}
    </Element>
  );
};

export default PathwayTestBlock;
